export const imageSource = {
  App: 'App',
  MachineWorker: 'MachineWorker',
  FileWorker: 'FileWorker',
  ProductionWorker: 'ProductionWorker',
  AppCameraOrPhotoLibrary: 'AppCameraOrPhotoLibrary',
  AppUploadFromFileSystem: 'AppUploadFromFileSystem',
  AppFromShare: 'AppFromShare',
};

export const connectionStatuses = { FAILED: 'failed' };
